import { Box, Spinner } from 'grommet';
import React from 'react';
import { HiOutlineCheck, HiOutlineXMark } from 'react-icons/hi2';

import { Button } from '@/components-new/button';

type EditingActionsCellProps = {
  disabled: boolean;
  saving: boolean;
  onSave: () => void;
  onCancel: () => void;
};

export const EditingActionsCell = (props: EditingActionsCellProps) => {
  const { disabled, saving, onSave, onCancel } = props;

  const handleCancel = () => {
    onCancel();
  };

  const handleSave = () => {
    onSave();
  };

  return (
    <Box direction="row" align="center">
      <Button
        plain
        aria-label="Cancel"
        onClick={handleCancel}
        disabled={disabled}
      >
        <HiOutlineXMark/>
      </Button>
      {!saving && <Button
        plain
        aria-label="Save"
        onClick={handleSave}
        disabled={disabled}
      >
        <HiOutlineCheck/>
      </Button>}
      {saving && <Spinner color="accent-1" size="xsmall"/>}
    </Box>
  );
};
